export const MEDIA_TYPES = {
    IMAGE: 'image',
    VIDEO: 'video',
}